import React from "react";
import { CalculatorOutlined, AuditOutlined, FileSearchOutlined, PieChartOutlined, BankOutlined, PartitionOutlined, TableOutlined } from "@ant-design/icons";
import QuickAccessWidget from "../common/QuickAccessWidget";

const SettlementQuickAccessWidget = (props) => {
    const items = [
        {
            label: "航班费用管理",
            path: "/settlement/leg-cost",
            icon: <CalculatorOutlined />,
            primary: true,
            permission: "settlement:read", // 结算读取权限
        },
        {
            label: "账单上传解析",
            path: "/settlement/invoice-data-sources",
            icon: <FileSearchOutlined />,
            primary: true,
            permission: "settlement_ap_invoice_data_source:read",
        },
        {
            label: "航线批量计算",
            path: "/settlement/batch-calculations",
            icon: <TableOutlined />,
            primary: true,
            permission: "settlement:read",
        },
        {
            label: "公共费用分摊",
            path: "/settlement/leg-cost?tab=cost-allocation",
            icon: <PartitionOutlined />,
            primary: false,
            permission: "settlement:allocate",
        },
        {
            label: "航段成本",
            path: "/settlement/leg-cost",
            icon: <BankOutlined />,
            primary: false,
            permission: "settlement:read",
        },
        {
            label: "航线成本看板",
            path: "/settlement/profit-reports",
            icon: <PieChartOutlined />,
            primary: false,
            permission: "settlement:read",
        },
    ];

    return <QuickAccessWidget title="结算中心" items={items} viewMorePath="/settlement/leg-cost" showTitle={false} showMenu={false} {...props} />;
};

export default SettlementQuickAccessWidget;
